import {
  FETCH_COMPANY_SETTINGS_REQUEST,
  FETCH_COMPANY_SETTINGS_SUCCESS,
  FETCH_COMPANY_SETTINGS_FAILURE,
  CREATE_COMPANY_SETTINGS_REQUEST,
  CREATE_COMPANY_SETTINGS_SUCCESS,
  CREATE_COMPANY_SETTINGS_FAILURE,
  UPDATE_COMPANY_SETTINGS_REQUEST,
  UPDATE_COMPANY_SETTINGS_SUCCESS,
  UPDATE_COMPANY_SETTINGS_FAILURE,
  DELETE_COMPANY_SETTINGS_REQUEST,
  DELETE_COMPANY_SETTINGS_SUCCESS,
  DELETE_COMPANY_SETTINGS_FAILURE,
} from "./types";

import {
  createCompanySettings,
  fetchCompanySettings,
  updateCompanySettings,
  deleteCompanySettings,
} from "../../services/companySettingsService";



// Fetch
export const fetchCompanySettingsRequest = () => ({
  type: FETCH_COMPANY_SETTINGS_REQUEST,
});
export const fetchCompanySettingsSuccess = (data) => ({
  type: FETCH_COMPANY_SETTINGS_SUCCESS,
  payload: data,
});
export const fetchCompanySettingsFailure = (error) => ({
  type: FETCH_COMPANY_SETTINGS_FAILURE,
  payload: error,
});

// Create
export const createCompanySettingsRequest = () => ({
  type: CREATE_COMPANY_SETTINGS_REQUEST,
});
export const createCompanySettingsSuccess = (data) => ({
  type: CREATE_COMPANY_SETTINGS_SUCCESS,
  payload: data,
});
export const createCompanySettingsFailure = (error) => ({
  type: CREATE_COMPANY_SETTINGS_FAILURE,
  payload: error,
});

// Update
export const updateCompanySettingsRequest = () => ({
  type: UPDATE_COMPANY_SETTINGS_REQUEST,
});
export const updateCompanySettingsSuccess = (data) => ({
  type: UPDATE_COMPANY_SETTINGS_SUCCESS,
  payload: data,
});
export const updateCompanySettingsFailure = (error) => ({
  type: UPDATE_COMPANY_SETTINGS_FAILURE,
  payload: error,
});

// Delete
export const deleteCompanySettingsRequest = () => ({
  type: DELETE_COMPANY_SETTINGS_REQUEST,
});
export const deleteCompanySettingsSuccess = (id) => ({
  type: DELETE_COMPANY_SETTINGS_SUCCESS,
  payload: id,
});
export const deleteCompanySettingsFailure = (error) => ({
  type: DELETE_COMPANY_SETTINGS_FAILURE,
  payload: error,
});

/* ========================
   Thunk Actions
======================== */

// Fetch active company settings
export const fetchCompanySettingsAction = () => async (dispatch) => {
  dispatch(fetchCompanySettingsRequest());
  try {
    const response = await fetchCompanySettings();
    if (response.success) {
      dispatch(fetchCompanySettingsSuccess(response.data));
    } else {
      dispatch(fetchCompanySettingsFailure(response.error));
    }
    return response;
  } catch (error) {
    dispatch(fetchCompanySettingsFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Create
export const createCompanySettingsAction = (data) => async (dispatch) => {
  dispatch(createCompanySettingsRequest());
  try {
    const response = await createCompanySettings(data);
    if (response.success) {
      dispatch(createCompanySettingsSuccess(response.data));
    } else {
      dispatch(createCompanySettingsFailure(response.error));
    }
    return response;
  } catch (error) {
    dispatch(createCompanySettingsFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Update
export const updateCompanySettingsAction = (companySettingsId, updates) => async (dispatch) => {
  dispatch(updateCompanySettingsRequest());
  try {
    const response = await updateCompanySettings(companySettingsId, updates);
    if (response.success) {
      dispatch(updateCompanySettingsSuccess(response.data));
    } else {
      dispatch(updateCompanySettingsFailure(response.error));
    }
    return response;
  } catch (error) {
    dispatch(updateCompanySettingsFailure(error.message));
    return { success: false, error: error.message };
  }
};

// Delete
export const deleteCompanySettingsAction = (companySettingsId) => async (dispatch) => {
  dispatch(deleteCompanySettingsRequest());
  try {
    const response = await deleteCompanySettings(companySettingsId);
    if (response.success) {
      dispatch(deleteCompanySettingsSuccess(companySettingsId));
    } else {
      dispatch(deleteCompanySettingsFailure(response.error));
    }
    return response;
  } catch (error) {
    dispatch(deleteCompanySettingsFailure(error.message));
    return { success: false, error: error.message };
  }
};
